import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const api = {
  // auth
  register: (p) => client.post("/auth/register", p).then((r) => r.data),
  login: (p) => client.post("/auth/login", p).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  users: () => client.get("/users").then((r) => r.data),
  createUser: (p) => client.post("/users", p).then((r) => r.data),
  updateUserRole: (id, role) => client.put(`/users/${id}/role`, { role }).then((r) => r.data),
  deleteUser: (id) => client.delete(`/users/${id}`).then((r) => r.data),
  // surveys
  listSurveys: () => client.get("/surveys").then((r) => r.data),
  createSurvey: (p) => client.post("/surveys", p).then((r) => r.data),
  getSurvey: (id) => client.get(`/surveys/${id}`).then((r) => r.data),
  updateSurvey: (id, p) => client.put(`/surveys/${id}`, p).then((r) => r.data),
  deleteSurvey: (id) => client.delete(`/surveys/${id}`).then((r) => r.data),
  generateAssets: (id) => client.post(`/surveys/${id}/generate-assets`).then((r) => r.data),
  uploadShowFile: (id, fd) => client.post(`/surveys/${id}/show-file`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  downloadShowFile: (id) => client.get(`/surveys/${id}/show-file`, { responseType: "blob" }).then((r) => r),
  deleteShowFile: (id) => client.delete(`/surveys/${id}/show-file`).then((r) => r.data),
  // photos
  listPhotos: (id) => client.get(`/surveys/${id}/photos`).then((r) => r.data),
  uploadPhoto: (id, fd) => client.post(`/surveys/${id}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  updatePhoto: (pid, p) => client.put(`/photos/${pid}`, p).then((r) => r.data),
  deletePhoto: (pid) => client.delete(`/photos/${pid}`).then((r) => r.data),
  // generic uploads
  upload: (fd) => client.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  // assets
  listAssets: (params) => client.get("/assets", { params }).then((r) => r.data),
  createAsset: (p) => client.post("/assets", p).then((r) => r.data),
  getAsset: (id) => client.get(`/assets/${id}`).then((r) => r.data),
  updateAsset: (id, p) => client.put(`/assets/${id}`, p).then((r) => r.data),
  deleteAsset: (id) => client.delete(`/assets/${id}`).then((r) => r.data),
  addPat: (id, p) => client.post(`/assets/${id}/pat`, p).then((r) => r.data),
  deletePat: (id, testId) => client.delete(`/assets/${id}/pat/${testId}`).then((r) => r.data),
  // maintenance
  listMaint: () => client.get("/maintenance").then((r) => r.data),
  createMaint: (p) => client.post("/maintenance", p).then((r) => r.data),
  updateMaint: (id, p) => client.put(`/maintenance/${id}`, p).then((r) => r.data),
  deleteMaint: (id) => client.delete(`/maintenance/${id}`).then((r) => r.data),
  // faults
  listFaults: (params) => client.get("/faults", { params }).then((r) => r.data),
  createFault: (p) => client.post("/faults", p).then((r) => r.data),
  updateFault: (id, p) => client.put(`/faults/${id}`, p).then((r) => r.data),
  deleteFault: (id) => client.delete(`/faults/${id}`).then((r) => r.data),
  // dashboard
  stats: () => client.get("/dashboard/stats").then((r) => r.data),
};
